<template>
  <div class="flex flex-fill p-0 main">
    <div class="header p-0 m-0 flex-row">
      <div
        class="logo-container d-flex flex-row justify-content-center align-items-center"
      >
        <router-link to="/create"
          ><div
            class="logo"
            v-bind:style="{ backgroundImage: 'url(' + logoUrl + ')', max }"
          ></div
        ></router-link>
      </div>

      <div
        class="title d-flex flex-row flex-fill justify-content-center align-items-center"
      >
        <h1>Commandes disponibles</h1>
      </div>
    </div>
    <div class="card-container flex flex-fill flex-row">
      <div
        class="d-inline col-sm-3 p-0 float-left"
        v-for="ticket in tickets"
        :key="ticket.key"
      >
        <div class="card-body">
          <div class="text-container d-flex flex-column justify-content-center">
            <span class="card-title">{{ ticket.number }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../firebaseDb";

export default {
  data() {
    return {
      tickets: [],
      restaurantId: 0,
      logoUrl: "",
    };
  },
  created() {
    this.restaurantId = this.$cookies.get("ods-restaurant-id");

    db.doc("restaurants/" + this.restaurantId)
      .get()
      .then((snapshotChange) => {
        const restaurantConfig = snapshotChange.data();
        this.logoUrl = restaurantConfig.logoUrl;
      });

    db.collection("restaurants/" + this.restaurantId + "/tickets").onSnapshot(
      (snapshotChange) => {
        this.tickets = [];
        snapshotChange.forEach((doc) => {
          this.tickets.push({
            key: doc.id,
            number: doc.data().number,
          });
        });
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 100vh;
  background-color: #262626;
  position: relative;

  .header {
    display: flex;
    flex: 1 1 auto;
    height: 15vh;
    width: 100vw;

    .logo-container {
      height: 15vh;
      .logo {
        color: white;
        position: absolute;
        left: 5vw;
        top: 0.1vw;
        height: 15vh;
        width: 200px;
        background-size: contain;
        background-repeat: no-repeat;
      }
    }

    .title {
      h1 {
        color: white;
        font-weight: 600;
        font-size: 4.7vw;
      }
    }
  }

  .card-container {
    height: 85vh;
    padding: 5vw;
    width: 100vw;
    background-repeat: no-repeat;
    background-size: cover;
    .card-body {
      margin: 1.5vh 1.5vw;
    }
  }
  .card-body {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
    background-color: white;
    color: #4a4a4a;
    height: 100%;
    border-radius: 15px;
    padding: 0;

    .text-container {
      height: 100%;

      .card-title {
        font-size: 20vh;
        font-weight: 900;
        text-align: center;
        margin-bottom: 0;
      }
    }
  }
}
</style>
